export const campaignConfig = {
    campaignListConfig: 'campaign_devapp', // campaign_devapp
    campaignHomePage: 'campaign_dhipaya',
    campaignFlashdeal: 'campaign_dhipaya_insurance_deal',
};

export const dashboardConfig = {
    mainDashboard: '',
    // dashboardHomePage: 'campaign_dhipaya_dashboard',
    dashboardHomePage: 'dhipaya_dashborad',
    dashboardReward: 'dhipaya_dashboard_reward',
};

export const categoryConfig = {
    menuCategory: 'menu_devapp',
    // menuCatePrivilege: 'menu_dhipaya_specialforyou',
    menuCatePrivilege: 'menu_dhipaya',
};

export const historyConfig = {
    purchase: 'purchase',
};
